import React from 'react';
import { Snackbar } from '../Snackbar/Snackbar';

function NotificationComponent(props) {
  const { message, duration, close } = props;

  return <Snackbar open={!!message} message={message} autoHideDuration={duration} onClose={close} />;
}

export default NotificationComponent;
